import { render } from "./PopupView.vue?vue&type=template&id=6c020912&scoped=true"
import script from "./PopupView.vue?vue&type=script&lang=js"
export * from "./PopupView.vue?vue&type=script&lang=js"

import "./PopupView.vue?vue&type=style&index=0&id=6c020912&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c020912"]])

export default __exports__